<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="事件类型">
            <a-select
              v-decorator="['execute_type']"
              allow-clear
              placeholder="请选择"
            >
              <a-select-option
                v-for="opt in eventTypeOptions"
                :key="opt.slug"
                :value="opt.slug"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'SearchEsimOperationRecords',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'esim_operation_records_search' }),
      eventTypeOptions: [
        { slug: 'download', name: '下载 Profile' },
        { slug: 'enable', name: '启用 Profile' },
        { slug: 'disable', name: '禁用 Profile' },
        { slug: 'delete', name: '删除 Profile' },
        { slug: 'set_fallback', name: '设置 Fallback' },
        { slug: 'unset_fallback', name: '取消 Fallback' }
      ]
    }
  },
  methods: {
    buildSearchParams(values) {
      const search = {}
      Object.keys(values || {}).forEach((key) => {
        const value = values[key]
        if (value === undefined || value === null || value === '') {
          return
        }
        search[key] = value
      })
      return search
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', this.buildSearchParams(values))
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
